import React, { useEffect, useState } from 'react';
import { find, map } from 'lodash';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import { addMinutes } from 'date-fns';

import MultipleSelectField from 'common/forms/MultipleSelectField';
import DateRangePickerField from 'common/forms/DateRangePickerField';
import { updatePrescriptionOrdersFilter } from 'store/thunks/orderStatusThunks';
import { OrderType } from 'enums/requestStatus.enum';
import { casingFormat } from 'common/utils';

const EScriptOrdersOuterFilters = () => {
  const dispatch = useDispatch();
  const [selectedPartner, setSelectedPartner] = useState('ALL');

  const partners = useSelector(
    ({ auth, partner: partnerStore }) => partnerStore[auth.currentTenantId]
  );
  const partnerNames = map(partners, (partner) => casingFormat(partner.partnerName));
  const filter = useSelector(({ orderStatus: { eScriptOrders } }) => eScriptOrders.filter);

  const onHandleDateChange = (dateRange) => {
    dispatch(
      updatePrescriptionOrdersFilter({
        filter: {
          ...filter,
          ...(dateRange && { createdAt: dateRange }),
          orderType: OrderType.E_SCRIPT,
        },
      })
    );
  };

  const onHandlePartnerFilter = (value) => {
    setSelectedPartner(value);
    dispatch(
      updatePrescriptionOrdersFilter({
        filter: {
          ...filter,
          partnerId:
            value === 'ALL'
              ? undefined
              : find(partners, (partner) => casingFormat(partner?.partnerName) === value)
                  ?.partnerUuid,
        },
      })
    );
  };

  useEffect(() => {
    if (!filter?.partnerId) {
      setSelectedPartner('ALL');
    }
  }, [filter]);

  return (
    <Grid container gap={2}>
      <Grid item>
        <MultipleSelectField
          id='Partner-Multiple-Select'
          name='partner'
          options={[...partnerNames, 'ALL']}
          label='Partner'
          selectedValue={selectedPartner}
          onChange={onHandlePartnerFilter}
        />
      </Grid>

      <Grid item>
        <DateRangePickerField
          label='Date Range'
          onDateChange={onHandleDateChange}
          initialValue={filter?.createdAt}
          maxDate={addMinutes(new Date(), 60)}
        />
      </Grid>
    </Grid>
  );
};

export default EScriptOrdersOuterFilters;
